/**
 * Block identifiers for content types
 */
const Blocks = {
  Text: "blocks.text",
  LaTeX: "blocks.tex",
  Heading: "blocks.heading",
  Spreadsheet: "blocks.calc",
  Markdown: "blocks.markdown",
  Image: "blocks.image",
  Video: "blocks.video",
  Model: "blocks.3d",
  Question: "blocks.quiz",
  MultipleChoice: "blocks.multiplechoice",
  Columns: "blocks.columns",
  Notes: "blocks.notes"
};

/**
 * Default empty block states for different
 * content block types upon creation
 */
export const BlockDefaults = {
  "blocks.text": { text: "" },
  "blocks.tex": { text: "" },
  "blocks.heading": { text: "" },
  "blocks.calc": { grid: [] },
  "blocks.markdown": { text: "" },
  "blocks.image": { url: "" },
  "blocks.video": { url: "" },
  "blocks.3d": { model: "" },
  "blocks.quiz": { question: "", answer: "" },
  "blocks.multiplechoice": { question: "", answers: [], correct: -1 },
  "blocks.columns": { blocksLeft: [], blocksRight: [] },
  "blocks.notes": { notes: "" }
};

export default Blocks;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/BlockTypes.js